import http from "./http_common";

class AppointmentService {
     queryString(payload) {
          const QueryString = Object.keys(payload).map((key) => (key && payload[key] && key + "=" + payload[key])).join('&');
          return QueryString;
     }

     AppointmentList(payload) {
          const queryString = Object.keys(payload).map((key) => (key && payload[key]) ? key + "=" + payload[key] : '').join("&");
          return http.get(`/patientAppointment/list/filter?${queryString}`)
     }
     AppointmentCount(payload) {
          const queryString = Object.keys(payload).map((key) => (key && payload[key]) ? key + "=" + payload[key] : '').join("&");
          return http.get(`/patientAppointment/patientAppointmentCountStatus?${queryString}`)
     }

     GetAppointmentId(id) {
          return http.get(`invitationDetails/list/filter?appointmentId=${id}`);
     }
     VitalMasterlist(payload) {
          const queryString = this.queryString(payload);
          return http.get(`vitalMaster/list/filter?${queryString}`);
     }

     AppointmentUpdate(data) {
          return http.put(`/invitationDetails/update-status/${data.id}`, data);
     }

     AppointmentCancel(data) {
          return http.put('/patientAppointment/cancel', data);
     }


     SlotTemplateSave(data) {
          return http.post('/appointmentTemplate/save', data);
     }

     UserSavedTemplates(data) {
          const queryString = this.queryString(data);
          return http.get(`/appointmentTemplate/list/filter?${queryString}`);
     }

     inactiveSelectedTemplate(id) {
          return http.put(`/appointmentTemplate/updateStatus/${id}`);
     }

     updateQueueOnJoinCall(payload) {
          return http.put(`patientAppointment/update/queue-joining-datetime`, payload);
     }

     updateQueueStatus(payload) {
          return http.put(`/patientAppointment/update/queue-status-endconsult`, payload);
     }

     rescheduleAppointment(data) {
          return http.put(`/patientAppointment/update/appointment-reschedule`, data);
     }

     AllConsReasons(data) {
          const queryString = this.queryString(data);
          return http.get(
               `/ChiefComplaintMaster/list/filter?pageNo=1&pageSize=30&${queryString}`
          );
     }

     requestToBookAppointment(payload) {
          return http.post('/RequestAppointment/', payload);
     }

     apptRequestList(payload) {
          const queryString = this.queryString(payload);
          return http.get(`/RequestAppointment/list/filter?${queryString}`);
     }

     requestApptConfirmation(payload){
          return http.put('/RequestAppointment/update', payload);
     }

}

export default new AppointmentService();